import NotificationContainer from './NotificationContainer';

export default NotificationContainer;
